module.exports = __webpack_public_path__ + "static/media/w (24).5fe286cb.jpg";